import { jsx as _jsx, jsxs as _jsxs } from "@emotion/react/jsx-runtime";
import { cloneElement, Fragment, isValidElement } from 'react';
import { useLinkStyles } from './link.styles';
import { BodyS, CaptionLink } from '../../typography';
const renderIcon = (icon, iconStyles)=>{
    if (!icon) return null;
    if (/*#__PURE__*/ isValidElement(icon) && icon.type === Fragment) {
        return icon.props.children;
    }
    return /*#__PURE__*/ cloneElement(icon, {
        css: iconStyles
    });
};
export const Link = ({ id, children, startIcon, endIcon, size = 'regular', onClick, themeName, className, fontWeight, isDisabled = false, ...ariaProps })=>{
    const styles = useLinkStyles({
        themeName
    });
    const Element = size === 'regular' ? BodyS : CaptionLink;
    return /*#__PURE__*/ _jsxs("button", {
        id: id,
        css: styles.container,
        className: className,
        type: "button",
        onClick: onClick,
        disabled: isDisabled,
        ...ariaProps,
        children: [
            renderIcon(startIcon, styles.icon),
            /*#__PURE__*/ _jsx(Element, {
                tag: "span",
                css: styles.link,
                color: "inherit",
                fontWeight: fontWeight,
                children: children
            }),
            renderIcon(endIcon, styles.icon)
        ]
    });
};

//# sourceMappingURL=link.js.map